import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'unicon-image-gallery',
  templateUrl: './image-gallery.component.html',
})
export class ImageGalleryComponent {
  @Input() selectedImage!: string;
  @Input() fullSize: boolean = false;
  @Input() closeAll: boolean = false;
  @Output() fullscreen: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
}
